import type { ErrorResponse } from 'epics/model/types';
import type { PersistedError } from 'state/persisted/types';

const jsonPayloadId = 'jsonPayload';

export const jsonPayloadPresent = (): boolean => {
    return document.getElementById(jsonPayloadId) != null;
};

export const getErrorFromJsonPayload = (): PersistedError | undefined => {
    const jsonPayload = document.getElementById(jsonPayloadId);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const errorResponse: ErrorResponse =
        (jsonPayload && jsonPayload.textContent && JSON.parse(jsonPayload.textContent)) || {};

    if (errorResponse && errorResponse.errorMessages) {
        return {
            error: {
                status: errorResponse.status,
                message: errorResponse.errorMessages[0],
                callToActionUrl: errorResponse.nextActionUrl || '',
                callToActionText: errorResponse.nextActionDisplayText || '',
            },
        };
    }
    return undefined;
};
